/* eslint-disable react/no-access-state-in-setstate */
/**
 * Created by zhang.weihua on 2018/3/20.
 */
/**
 * props参数
 * cascade 默认是3  //2级就传1，3级就传2,省市区街道
 * ok  //func(item)  选择之后的回调函数, item是选中的市
 * visible //modal展示
 * onClose //关闭modal事件
 * value初始值 [Array][{label:xxx省,value:123334}]//label不是必须值，value是省市区街道对应的code
 * 数组顺序是[{省}{市}{区}{街道}]
 * changeOnSelect:true // 默认false  为true时每选择一级都会提交（change）选中的地区值
 */
import React, { Component } from 'react';
import { Flex, Toast, Modal, Icon, Button } from 'antd-mobile';
import Request from 'utils/request';
import './index.less';
import { find, findIndex, get } from 'lodash';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import config from 'config/Config';
import { inject } from 'mobx-react';

const defaultItem = { label: '请选择' };

@inject('AppMod')
class AddressPickerView extends Component {
  constructor(props, context) {
    super(props, context);
    this.appStore = this.props.AppMod;
    this.state = {
      show: false,
      loading: false,
      areaData: [], // 总数据
      areaList: [], // 显示数据
      selectedArea: [defaultItem], // 0,1,2,3-->省，市，区,街道
      index: 0, // 表示进行到那个tab
      error: false // 是否显示错误处理
    };
    // lngName：0 : 国内地址 1:国际地址
    // 需要突破国际站使用国际地址，国内站使用国内地址的限制，请传入customLngName
    this.lngName =
      props.customLngName !== undefined
        ? props.customLngName
        : this.appStore.isInternationalized
          ? 1
          : 0;
    this.cascade = Math.min(props.cascade || 3, 3); // 最高只到街道级，不选社区
    this.isWithDraw = props.isWithDraw || false; // 是否是提现页面
    this.streetRequired = props.streetRequired || false; // 街道是否必选
    this.communityRequired = props.communityRequired || false; // 社区是否必选
    this.changeOnSelect = props.changeOnSelect || false;
    this.curData = [];
    if (props.visible) {
      this.stopBodyScroll(true);
    }

    this.getAreas = this.getAreas.bind(this);
    this.getAreaValue = this.getAreaValue.bind(this);
  }

  componentDidMount() {
    console.log('this.props-------', this.props);

    // 进来时，加载数据，以及根据数据和传递过来的默认值展示初始状态
    this.getAreas('0').then(() => {
      this.getAreaValue().then((res) => {
        this.setState({
          ...res
        });
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && nextProps.visible !== this.props.visible) {
      this.stopBodyScroll(true);
    }
  }

  // 查询地址
  async getAreas(parentCode, level) {
    if (!parentCode) {
      this.setState({
        areaList: [],
        error: false
      });
      return;
    }
    this._toggleLoading();
    this.setState({ areaList: [] }); // 获取数据时，只更新展示区的数据为空

    // 社区级使用单独接口
    let reqUrl;
    if (level === 4) {
      reqUrl = `basic/community/queryJointCreationCommunityParentCode?parentCode=${parentCode}`;
    } else {
      reqUrl = parentCode
        ? `basic/area/queryByParentCode/${parentCode}?name=${this.lngName}`
        : 'basic/area/allArea';
      this.isWithDraw && (reqUrl = `basic/area/queryByParentCode/${parentCode}?name=0`); // 如果是提现页面，则走国内地址
    }
    this.code = parentCode; // 记录当前请求的code，用来刷新
    this.requestLevel = level; // 记录当前请求的层级，用来刷新
    await Request({
      url: reqUrl,
      host: config.HOST_MALL,
      method: 'get',
      data: this.props.params || {}
    }).then(
      (result) => {
        this._toggleLoading();
        // 不需要更新areaData
        if (this.code) {
          // 格式化后台返回街道数据
          const list = [];
          for (const item of result.data) {
            list.push({
              ...item,
              label: item.name,
              value: item.code
            });
          }

          this.curData = list;
          this.setState({
            areaList: list,
            error: false
          });
        } else {
          this.setState({
            areaList: result.data,
            areaData: result.data,
            error: false
          });
        }
      },
      (err) => {
        this._toggleLoading();
        this.setState({
          error: true
        });
      }
    );
  }

  getAreaDataIndex = (list, index, arr, codes) => {
    list.forEach((e, i) => {
      if (e.value == codes[index]) {
        arr.push(e);
        if (Array.isArray(e.children)) {
          this.getAreaDataIndex(e.children, index + 1, arr, codes);
        }
      }
    });
  };

  getAreaData = (indexArray, list) => {
    let arr = [];
    this.getAreaDataIndex(list, 0, arr, indexArray);
    return arr;
  };

  getCascadingDataIndex = (list, index, arr, codes) => {
    arr.push(list);
    console.log('getCascadingDataIndex', list, codes, index, arr);
    list.forEach((e, i) => {
      if (e.value == codes[index] && Array.isArray(e.children) && e.children.length > 0) {
        this.getCascadingDataIndex(e.children, index + 1, arr, codes);
      }
    });
  };

  getCascadingData = (indexArray, list) => {
    let arr = [];
    this.getCascadingDataIndex(list, 0, arr, indexArray);
    return arr;
  };

  getTreeData = (data, index) => {
    return data.map((e) => {
      const children = e.children ? this.getTreeData(e.children, index + 1) : [];
      // 区级始终显示"暂不选择"（街道可选）
      if (index == 2) {
        children.unshift({ label: '暂不选择', value: '' });
      }
      // 街道级且社区非必选
      if (index == 3 && !this.communityRequired) {
        children.unshift({ label: '暂不选择', value: '' });
      }
      return {
        ...e,
        children
      };
    });
  };

  // 获取设置的值
  async getAreaValue() {
    const { value } = this.props;
    // const newValue = (value || []).filter((e) => e && e.value);
    const newValue = (value || []).filter((e) => e);
    console.log('newValue', newValue);
    if (Array.isArray(newValue) && newValue.length > 0) {
      let parentCode = '';
      if (value.length == 1) {
        parentCode = '0';
      } else {
        parentCode = value[value.length - 2].value;
      }
      let selectedArea = value;
      this.getAreas(parentCode).then(() => {
        this.curData = this.state.areaList;
        this.setState({
          selectedArea: selectedArea,
          index: value.length - 1
        });
      });
    }
  }

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = this.closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  };

  openModal = () => {
    this.stopBodyScroll(true);
    this.setState({
      show: true
    });
  };

  _onClose = () => {
    this.stopBodyScroll(false);
    this.props.onClose && this.props.onClose();
  };

  // 切换loading状态
  _toggleLoading = () => {
    const { loading } = this.state;
    this.setState({
      loading: !loading,
      error: false
    });
  };

  getSelectData = (selectData) => {
    return selectData.filter((e) => e.children || e.label == '请选择');
  };

  // 区域选择
  _areaClick = async (item, idx) => {
    let { selectedArea, index } = this.state;
    selectedArea[index] = item;

    document.getElementsByClassName('area-content')[0].scrollTop = 0;

    // 点击"暂不选择"时，直接关闭不再请求下一级，不回显
    if (item.label === '暂不选择') {
      this._onClose();
      this.props.ok && this.props.ok(selectedArea.slice(0, index));
      return;
    }

    if (index < this.cascade) {
      const nextLevel = index + 1;
      this.getAreas(item.value, nextLevel).then(() => {
        this.curData = this.state.areaList;
        index = index + 1;
        selectedArea[index] = defaultItem;
        this.setState({
          selectedArea: selectedArea,
          index: index
        });
      });
    } else {
      this.setState({
        selectedArea: selectedArea
      });
      this._onClose();
      this.props.ok && this.props.ok(selectedArea);
    }

    this.changeOnSelect && this.props.ok && this.props.ok(selectedArea);
  };

  // 切换tab
  _tabClick = (index) => {
    const { selectedArea } = this.state;
    let parentCode = '';
    // 选到请选择
    if (selectedArea.length - 1 == index) {
      parentCode = selectedArea[index - 1].value;
      this.setState({ error: false });
      if (this.state.index != index) {
        this.getAreas(parentCode, index).then(() => {
          this.curData = this.state.areaList;
          this.setState({
            selectedArea: selectedArea,
            index: index
          });
        });
      }
    } else {
      this.setState({ error: false });
      if (this.state.index != index) {
        if (index === 0) {
          parentCode = '0';
        } else {
          parentCode = selectedArea[index - 1].value;
        }
        this.getAreas(parentCode, index).then(() => {
          this.curData = this.state.areaList;

          const selectedAreaData = selectedArea.splice(0, index + 1);
          selectedAreaData[index + 1] = defaultItem;
          this.setState({
            selectedArea: selectedAreaData,
            index: index
          });
        });
      }
    }
  };

  // 网络请求失败刷新重试
  _refresh = () => {
    // 判断是省市区还是街道/社区的
    const { index, selectedArea } = this.state;
    if (index === 3 || index === 4) {
      this.getAreas(selectedArea[index - 1].value, index);
    } else {
      this.getAreas();
    }
  };

  closest(el, selector) {
    const matchesSelector =
      el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  stopBodyScroll(isFixed) {
    const bodyEl = document.body;
    let top = 0;
    if (isFixed) {
      top = window.scrollY;

      bodyEl.style.position = 'fixed';
      bodyEl.style.top = `${-top}px`;
    } else {
      top = Math.abs(parseInt(bodyEl.style.top));
      bodyEl.style.position = '';
      bodyEl.style.top = '';

      window.scrollTo(0, top); // 回到原先的top
    }
  }

  render() {
    const { isInternationalized } = this.appStore;
    // 不允许修改省
    const { disabledProvi } = this.props;
    const { selectedArea, index, areaList } = this.state;
    const currentArea = selectedArea[index];
    let list = areaList;
    if (index == 2 && isInternationalized) {
      list = [{ label: '暂不选择', value: '' }, ...list];
    }
    if (index == 3) {
      list = [{ label: '暂不选择', value: '' }, ...list];
    }
    // 社区级：始终显示"暂不选择"
    if (index == 4) {
      list = [{ label: '暂不选择', value: '' }, ...list];
    }
    return (
      <Modal
        className="address-picker-modal"
        popup
        visible={this.props.visible}
        animationType="slide-up"
        onClose={this._onClose}
        wrapProps={{ onTouchStart: this.onWrapTouchStart }}>
        <div className="address-picker-widget">
          <div className="address-header">
            <span>所在地区</span>
            <span className="iconfont icon-quxiao icon-close" onClick={this._onClose} />
          </div>
          <Flex className="area-tabs">
            {this.state.selectedArea.map((item, index) => (
              <div
                style={index == 0 && disabledProvi ? { color: 'grey' } : {}}
                className="tab"
                key={`tab${index}`}
                onClick={index == 0 && disabledProvi ? () => {} : this._tabClick.bind(this, index)}>
                <div className={index === this.state.index ? 'tab-text active' : 'tab-text'}>
                  <span className="tab-btn" />
                  {item.label}
                </div>
              </div>
            ))}
          </Flex>
          <div className="area-content">
            {list.map((item, idx) => {
              const selected = get(currentArea, 'value') === item.value;
              return (
                <div
                  className={`area-item ${selected ? 'active' : ''}`}
                  key={`area_item_${idx}`}
                  onClick={this._areaClick.bind(this, item, idx)}>
                  {item.label}
                </div>
              );
            })}
          </div>
          {this.state.loading ? (
            <Flex className="loading" justify="center">
              <Icon type="loading" />
            </Flex>
          ) : null}

          {this.state.error && (
            <Flex className="error-wrapper" justify="center">
              <CommonBtn onClick={this._refresh} className="refresh-btn" title="刷新重试" />
            </Flex>
          )}
        </div>
      </Modal>
    );
  }
}

module.exports = AddressPickerView;



// WEBPACK FOOTER //
// ./src/widget/AddressPicker/index.js